import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import Dashboard from './Dashboard';

import CreateCourse from './CreateCourse';
import UpdateCourse from './UpdateCourse';
import CourseRunDemands from './CourseRunDemands';
import MyCourseRunDemands from './MyCourseRunDemands';
import CourseRunDemandsDetail from './CourseRunDemandsDetail';

import OrganizationForm from './OrganizationForm';
import OrganizationSingle from './OrganizationSingle';

import InstructorForm from './InstructorForm';
import InstructorSingle from './InstructorSingle';

import Toast from '../../components/Toast';

import setAuthToken from '../../utils/setAuthToken';
import Cookie from 'js-cookie';
import CourseList from './CourseList';
import {
  COURSE_LIST_PATH,
  COURSE_RUN_DEMANDS_DETAIL_PATH,
  COURSE_RUN_DEMANDS_PATH,
  CREATE_COURSE_PATH,
  DASHBOARD_PATH,
  INSTRUCTOR_FORM_EDIT_PATH,
  INSTRUCTOR_FORM_NEW_PATH,
  INSTRUCTOR_SINGLE_PATH,
  MY_COURSE_RUN_DEMANDS_PATH,
  ORG_COURSE_PATH,
  ORG_FORM_PATH,
  ORG_SINGLE_PATH,
  UPDATE_COURSE_PATH,
} from '../../utils/AllRoutes';
import { canAccessThisRoute } from '../../utils/PermissionManager';

export default function HomePage() {
  const { permissions, isLoading, selectedRole, selectedOrg, data: userData } = useSelector(state => state.permission);

  let errors = useSelector(state => state.error);

  const token = Cookie.get('edx-jwt-cookie');
  setAuthToken(token);

  useEffect(() => {
    errors.forEach(item => {
      Toast(item.message, 'error');
    });
  }, [errors]);

  // init matomo
  useEffect(() => {
    if (selectedOrg?.id) {
      var _paq = (window._paq = window._paq || []);
      _paq.push(['setCustomDimension', 1, selectedOrg.id || 'AnanymousUser']);
      _paq.push(['setCustomDimension', 2, selectedOrg.name || 'No Organization']);
      _paq.push(['setCustomDimension', 3, userData.username || 'AnanymousUser']);
      _paq.push(['setUserId', userData.fullname]);
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u = '//matomo.mparsict.com/';
        _paq.push(['setTrackerUrl', u + 'matomo.php']);
        _paq.push(['setSiteId', '1']);
        var d = document,
          g = d.createElement('script'),
          s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = u + 'matomo.js';
        s.parentNode.insertBefore(g, s);
      })();
    }
  }, [selectedOrg]);

  return (
    <Switch>
      <Route
        exact
        path={DASHBOARD_PATH}
        component={canAccessThisRoute(selectedRole, DASHBOARD_PATH) && !isLoading && Dashboard}
      />
      {/* <Route
        exact
        path='/user-requests'
        component={permissions && !isLoading && UserRequests}
      /> */}
      <Route
        exact
        path={COURSE_RUN_DEMANDS_PATH}
        component={canAccessThisRoute(selectedRole, COURSE_RUN_DEMANDS_PATH) && !isLoading && CourseRunDemands}
      />
      <Route
        exact
        path={COURSE_RUN_DEMANDS_DETAIL_PATH}
        component={
          canAccessThisRoute(selectedRole, COURSE_RUN_DEMANDS_DETAIL_PATH) && !isLoading && CourseRunDemandsDetail
        }
      />
      <Route
        exact
        path={MY_COURSE_RUN_DEMANDS_PATH}
        component={canAccessThisRoute(selectedRole, MY_COURSE_RUN_DEMANDS_PATH) && !isLoading && MyCourseRunDemands}
      />
      <Route
        exact
        path={COURSE_LIST_PATH}
        component={canAccessThisRoute(selectedRole, COURSE_LIST_PATH) && !isLoading && CourseList}
      />
      <Route
        exact
        path={CREATE_COURSE_PATH}
        component={canAccessThisRoute(selectedRole, CREATE_COURSE_PATH) && !isLoading && CreateCourse}
      />
      <Route
        exact
        path={UPDATE_COURSE_PATH}
        component={canAccessThisRoute(selectedRole, UPDATE_COURSE_PATH) && !isLoading && UpdateCourse}
      />
      <Route
        exact
        path={ORG_COURSE_PATH}
        component={canAccessThisRoute(selectedRole, ORG_COURSE_PATH) && !isLoading && OrganizationForm}
      />
      <Route
        exact
        path={ORG_SINGLE_PATH}
        component={canAccessThisRoute(selectedRole, ORG_SINGLE_PATH) && !isLoading && OrganizationSingle}
      />
      <Route
        exact
        path={ORG_FORM_PATH}
        component={canAccessThisRoute(selectedRole, ORG_FORM_PATH) && !isLoading && OrganizationForm}
      />
      <Route
        exact
        path={INSTRUCTOR_FORM_NEW_PATH}
        component={canAccessThisRoute(selectedRole, INSTRUCTOR_FORM_NEW_PATH) && !isLoading && InstructorForm}
      />
      <Route
        exact
        path={INSTRUCTOR_FORM_EDIT_PATH}
        component={canAccessThisRoute(selectedRole, INSTRUCTOR_FORM_EDIT_PATH) && !isLoading && InstructorForm}
      />

      <Route
        exact
        path={INSTRUCTOR_SINGLE_PATH}
        component={canAccessThisRoute(selectedRole, INSTRUCTOR_SINGLE_PATH) && !isLoading && InstructorSingle}
      />
      <Redirect to="/error/404" />
    </Switch>
  );
}
